import React from "react";
import { Form } from "react-bootstrap";
import {
    // useFormikContext,
    useField
} from "formik";

const BCSelectFieldManual = ({ controlId, label, size, children, ...props }) => {
    const [field, meta] = useField(props);
    //  const { setFieldValue, setFieldTouched } = useFormikContext();

    return (
        <Form.Group controlId={controlId}>
            <Form.Label>{label}</Form.Label>
            <Form.Control
                {...props}
                {...field}
                as="select"
                isInvalid={meta.error && meta.touched}
                isValid={!meta.error && meta.touched}
                size={size}
                onChange={props.onChange}
            >
                {children}
            </Form.Control>
            {meta.error && meta.touched ? (
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
            ) : null}
        </Form.Group>
    );
};

BCSelectFieldManual.defaultProps = {
    size: "md"
};

export default BCSelectFieldManual;
